import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap'
import './styles/main.scss';
import AuthInterceptor from "./interceptors/auth-interceptor";

AuthInterceptor();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);